import { useState } from 'react';
import { RefreshCw, ScanLine } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { InvoiceWorkspace } from '../components/invoice/InvoiceWorkspace';
import { FilesCheck } from '../components/invoice/FilesCheck';

export default function ControleFacturesPage() {
    const navigate = useNavigate();
    const [month, setMonth] = useState(() => new URLSearchParams(window.location.search).get('mois') || '');
    const [counts, setCounts] = useState({});
    const [key, setKey] = useState(0);
    return (
        <div className="h-[calc(100vh-0px)] flex flex-col px-4 sm:px-6 py-5 gap-4" data-testid="controle-factures-page">
            <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                    <h1 className="text-xl font-semibold text-gray-900">Contrôle des factures</h1>
                    <p className="text-[13px] text-gray-500"><span className="font-semibold text-amber-700" data-testid="invoice-pending-count">{counts.en_attente_total ?? '…'}</span> facture(s) en attente de traitement</p>
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    <Button size="sm" onClick={() => navigate('/scan-factures')} className="bg-[#6366F1] hover:bg-[#4F46E5] text-white" data-testid="invoice-go-scan"><ScanLine className="w-4 h-4 mr-1" />Scanner des factures</Button>
                    <FilesCheck />
                    <Button variant="outline" size="sm" onClick={() => setKey(k => k + 1)} data-testid="invoice-refresh"><RefreshCw className="w-4 h-4 mr-1" />Actualiser</Button>
                </div>
            </div>
            <InvoiceWorkspace key={key} month={month} onMonth={setMonth} onData={r => setCounts(r.compteurs)} />
        </div>
    );
}
